import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import { getFoxMediaLinkList } from "@/pages/profile/helper/getFoxMediaLinkList";
import { useGlobalStore } from "@/store/GlobalStore";
import { BindQqIcon } from "@/pages/profile/components/bind-account-icon";
import { getJumpLink } from "@/pages/profile/constant/fox-meda-link";
import { useTranslation } from "react-i18next";
import { FoxMediaLink } from "@/pages/profile/constant/fox-meda-link";

interface BindAccountData {
  type: FoxMediaLink;
  nickname?: string;
  [k: string]: any;
}

export function useFoxMediaLink() {
  const { isSubAccount, userInfo } = useGlobalStore();
  const [bindList, setBindList] = useState<BindAccountData[]>([]);

  const { data } = useQuery<BindAccountData[]>(
    "/api/rendering/user/querySocialMediaBindList"
  );
  useEffect(() => {
    if (!data) return;
    const foxMediaLinkList = getFoxMediaLinkList(data);
    !isSubAccount && setBindList(foxMediaLinkList);
  }, [data, isSubAccount, userInfo?.userId]);

  const bindAccount = (type: FoxMediaLink) => {
    const jumpLink = getJumpLink(type);
    if (!jumpLink) return;
    window.open(jumpLink, "_self", "noopener,noreferrer");
  };

  const [openUnbindModal, setOpenUnbindModal] = useState(false);
  const bindAccountMeta = useFoxMediaLinkMeta();
  return {
    bindList,
    bindAccount,
    openUnbindModal,
    setOpenUnbindModal,
    bindAccountMeta,
  };
}

export const useFoxMediaLinkMeta = () => {
  const { t } = useTranslation("profile");
  return {
    [FoxMediaLink.Linkedin]: {
      icon: BindQqIcon,
      name: t("Linkedin"),
    },
    [FoxMediaLink.Instagram]: {
      icon: BindQqIcon,
      name: t("Instagram"),
    },
    [FoxMediaLink.Facebook]: {
      icon: BindQqIcon,
      name: t("Facebook"),
    },
    [FoxMediaLink.X]: {
      icon: BindQqIcon,
      name: t("X"),
    },
    [FoxMediaLink.Youtube]: {
      icon: BindQqIcon,
      name: t("Youtube"),
    },
  };
};
